export const getSanitizedSubmitValues = (id, values) => {
  const sanitizedValues = Object.keys(values).map((item) => {
    return {
      patientSurveyId: +id,
      surveyItemId: +item,
      value: values[item]
    };
  }).filter((item) => item.value !== '');

  return {answers: sanitizedValues};
};
